// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1_gSf","footer":"ReportModalFilter_footer__35kQP"};